/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { HotelRoomTypeListResponse } from '../model';
// @ts-ignore
import { RoomMinPriceRangeResponse } from '../model';
// @ts-ignore
import { RoomPriceListingResponse } from '../model';
/**
 * HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGet - axios parameter creator
 * 
 * @param {number} [roomTypeId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetAxiosParamCreator (roomTypeId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/HotelRoom/deleteRoomType/roomTypeId`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (roomTypeId !== undefined) {
        localVarQueryParameter['roomTypeId'] = roomTypeId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGet - axios parameter creator
 * 
 * @param {number} hotelId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetAxiosParamCreator (hotelId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'hotelId' is not null or undefined
    assertParamExists('apiHotelRoomGetHotelRoomsHotelIdGet', 'hotelId', hotelId)
    const localVarPath = `/api/HotelRoom/getHotelRooms/{hotelId}`
        .replace(`{${"hotelId"}}`, encodeURIComponent(String(hotelId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelRoomApiApiHotelRoomMinPriceGet - axios parameter creator
 * 
 * @param {number} [cityId] 
 * @param {string} [start] 
 * @param {string} [end] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [roomCount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelRoomApiApiHotelRoomMinPriceGetAxiosParamCreator (cityId?: number, start?: string, end?: string, adultCount?: number, childCount?: number, roomCount?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/HotelRoom/min-price`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (cityId !== undefined) {
        localVarQueryParameter['cityId'] = cityId;
    }

    if (start !== undefined) {
        localVarQueryParameter['start'] = (start as any instanceof Date) ?
            (start as any).toISOString() :
            start;
    }

    if (end !== undefined) {
        localVarQueryParameter['end'] = (end as any instanceof Date) ?
            (end as any).toISOString() :
            end;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (roomCount !== undefined) {
        localVarQueryParameter['roomCount'] = roomCount;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelRoomApiApiHotelRoomPriceListingsRoomIdGet - axios parameter creator
 * 
 * @param {string} roomId 
 * @param {string} [from] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelRoomApiApiHotelRoomPriceListingsRoomIdGetAxiosParamCreator (roomId: string, from?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'roomId' is not null or undefined
    assertParamExists('apiHotelRoomPriceListingsRoomIdGet', 'roomId', roomId)
    const localVarPath = `/api/HotelRoom/price-listings/{roomId}`
        .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelRoomDeleteRoomTypeRoomTypeIdGet operation in HotelRoomApi.
 * @export
 * @interface HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetRequest
 */
export interface HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGet
     */
    readonly roomTypeId?: number
}

/**
 * Request parameters for apiHotelRoomGetHotelRoomsHotelIdGet operation in HotelRoomApi.
 * @export
 * @interface HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetRequest
 */
export interface HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGet
     */
    readonly hotelId: number
}

/**
 * Request parameters for apiHotelRoomMinPriceGet operation in HotelRoomApi.
 * @export
 * @interface HotelRoomApiApiHotelRoomMinPriceGetRequest
 */
export interface HotelRoomApiApiHotelRoomMinPriceGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly cityId?: number

    /**
     * 
     * @type {string}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly start?: string

    /**
     * 
     * @type {string}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly end?: string

    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof HotelRoomApiApiHotelRoomMinPriceGet
     */
    readonly roomCount?: number
}

/**
 * Request parameters for apiHotelRoomPriceListingsRoomIdGet operation in HotelRoomApi.
 * @export
 * @interface HotelRoomApiApiHotelRoomPriceListingsRoomIdGetRequest
 */
export interface HotelRoomApiApiHotelRoomPriceListingsRoomIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelRoomApiApiHotelRoomPriceListingsRoomIdGet
     */
    readonly roomId: string

    /**
     * 
     * @type {string}
     * @memberof HotelRoomApiApiHotelRoomPriceListingsRoomIdGet
     */
    readonly from?: string
}

/**
* 
* @param {HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGet(requestParameters: HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelRoomApiApiHotelRoomDeleteRoomTypeRoomTypeIdGetAxiosParamCreator(requestParameters.roomTypeId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGet(requestParameters: HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelRoomApiApiHotelRoomGetHotelRoomsHotelIdGetAxiosParamCreator(requestParameters.hotelId, options, configuration);
    const request: () => AxiosPromise<HotelRoomTypeListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelRoomApiApiHotelRoomMinPriceGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelRoomApiApiHotelRoomMinPriceGet(requestParameters: HotelRoomApiApiHotelRoomMinPriceGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelRoomApiApiHotelRoomMinPriceGetAxiosParamCreator(requestParameters.cityId, requestParameters.start, requestParameters.end, requestParameters.adultCount, requestParameters.childCount, requestParameters.roomCount, options, configuration);
    const request: () => AxiosPromise<RoomMinPriceRangeResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelRoomApiApiHotelRoomPriceListingsRoomIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelRoomApiApiHotelRoomPriceListingsRoomIdGet(requestParameters: HotelRoomApiApiHotelRoomPriceListingsRoomIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelRoomApiApiHotelRoomPriceListingsRoomIdGetAxiosParamCreator(requestParameters.roomId, requestParameters.from, options, configuration);
    const request: () => AxiosPromise<RoomPriceListingResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
